import { auth } from "../firebase";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function getHeaders() {
  const user = auth.currentUser;

  if (!user) {
    return null;
  }

  const token = await user.getIdToken();

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function api(path, options = {}) {
  const headers = await getHeaders();

  if (!headers) {
    return { ok: false, unauthenticated: true };
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...headers,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.error || "Request failed");
  }

  return data;
}

function normalizeProduct(product) {
  const id = String(product?.product_id || product?.variant_id || product?.id || "");

  return {
    product_id: id,
    name: product?.name || "Product",
    price: Number(product?.price ?? 0),
    old_price: product?.old_price != null ? Number(product.old_price) : null,
    image_url: product?.image_url || "",
    image_proxy_url: product?.image_proxy_url || "",
  };
}

export async function apiGetCart() {
  return api("/api/cart", { method: "GET" });
}

export async function apiAddToCart(product, qty = 1) {
  return api("/api/cart/items", {
    method: "POST",
    body: JSON.stringify({
      product_id: String(product?.product_id || product?.variant_id || product?.id || ""),
      qty,
      product: normalizeProduct(product),
    }),
  });
}

export async function apiDecrementCart(productId, qty = 1) {
  return api(`/api/cart/items/${encodeURIComponent(productId)}/decrement`, {
    method: "PATCH",
    body: JSON.stringify({ qty }),
  });
}

export async function apiRemoveCartItem(productId) {
  return api(`/api/cart/items/${encodeURIComponent(productId)}`, {
    method: "DELETE",
  });
}

export async function apiClearCart() {
  return api("/api/cart", {
    method: "DELETE",
  });
}